module.exports = __webpack_public_path__ + "media/img/pages/profile/zhaw ger 1-ea2eeaa24f4f8c90ead1135b8350e0c1.jpg";